import React from "react";
import { Form } from "semantic-ui-react";

const ages = () => [
  { key: "empty", text: "", value: "" },
  { key: "0020", text: "< 20", value: "0020" },
  { key: "2030", text: "20 - 30", value: "2030" },
  { key: "3040", text: "30 - 40", value: "3040" },
  { key: "4050", text: "40 - 50", value: "4050" },
  { key: "5099", text: "> 50", value: "5099" },
];

export const AgeListDropdown = ({ intlh, ...others }) => (
  <Form.Select options={ages(intlh)} {...others} />
);
